import { render, staticRenderFns } from "./WochitGoQr.vue?vue&type=template&id=359c445c&scoped=true&"
import script from "./WochitGoQr.vue?vue&type=script&lang=js&"
export * from "./WochitGoQr.vue?vue&type=script&lang=js&"
import style0 from "./WochitGoQr.vue?vue&type=style&index=0&id=359c445c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c445c",
  null
  
)

export default component.exports